import React from 'react';
import { Box, Grid2, Stack, Paper, Typography} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import HistoryIcon from '@mui/icons-material/History';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StatCard from '../../Components/Card/StatCard';
import SessionsBChart from '../../Components/BarCharts/SessionsBChart';
import AssessmentsBChart from '../../Components/BarCharts/AssessmentsBChart';
import AbsentPresentChart from '../../Components/BarCharts/AbsentPresentChart';
import { GroupAddRounded, Percent } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import Gate from '../Gate';
import { ROOT } from '../../Static/static';
import { fallback } from '../AdminHomeHelper';

const ExecutivePulse = ({ guageData, loading, assessments, sessions }) => {

    const perms = useSelector((state) => state.role.permissions);
    const sysRole = useSelector((state) => state.role.role);
    const canGlobal = perms.includes("view:analytics:global");
    const canAssessment  = perms.includes("view:analytics:assessment");
  
  return (
    <Box>
    <Grid2 container spacing={2} sx={{ mb: 3 }}>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Total Students" value={guageData.studentCount} icon={<PeopleIcon />} loading={loading} color="primary" />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Total Sessions" value={guageData.sessionCount} icon={<HistoryIcon />} loading={loading} color="secondary" />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Assessments" value={guageData.assessmentCount} icon={<AssessmentIcon />} loading={loading} color="info" />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Pass rate" value={guageData.passRate} icon={<Percent />} loading={loading} color="primary" percentage positiveTrend={guageData.passRate > Number(70) ? true: false} />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Avg Session duration" value={guageData.averageSessionDuration} icon={<AccessTimeIcon />} loading={loading} color="success" decimals={1} />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 3, md: 2 }}>
        <StatCard title="Student avg per session" value={guageData.averageStudentPerSession} icon={<GroupAddRounded />} loading={loading} color="success" />
      </Grid2>
    </Grid2>
    <Grid2 container spacing={2} sx={{ display: 'flex', alignItems: 'stretch' }}> {/* 1. Ensure stretch */}
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Gate allow={sysRole === ROOT || canGlobal} fallback={fallback("view:analytics:session")}>
          <Paper 
            elevation={0} 
            variant="outlined" 
            sx={{ 
              p: 1, 
              bgcolor: 'background.paper', 
              height: '100%',     // 2. Fill the available height
              display: 'flex',    // 3. Make the paper a flex container
              flexDirection: 'column' 
            }}
          >
            <Box sx={{ flexGrow: 1 }}> {/* 4. Allow chart box to expand */}
              <SessionsBChart data={sessions} />
            </Box>
          </Paper>
        </Gate>
      </Grid2>

      <Grid2 size={{ xs: 12, md: 6 }}>
      <Gate allow={sysRole === ROOT || canAssessment} fallback={fallback("view:analytics:assessments")}>
        <Paper 
          elevation={0} 
          variant="outlined" 
          sx={{ 
            p: 1, 
            bgcolor: 'background.paper', 
            height: '100%',     // 2. Fill the available height
            display: 'flex',    // 3. Make the paper a flex container
            flexDirection: 'column' 
          }}
        >
          <Box sx={{ flexGrow: 1 }}> {/* 4. Allow chart box to expand */}
            <AssessmentsBChart data={assessments} />
          </Box>
        </Paper>
        </Gate>
      </Grid2>
    </Grid2>
    </Box>
  );
};

export default ExecutivePulse;